import { render, staticRenderFns } from "./docLabel.vue?vue&type=template&id=7cb28ad9&scoped=true&"
import script from "./docLabel.vue?vue&type=script&lang=js&"
export * from "./docLabel.vue?vue&type=script&lang=js&"
import style0 from "./docLabel.vue?vue&type=style&index=0&id=7cb28ad9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb28ad9",
  null
  
)

export default component.exports